module.exports = __webpack_public_path__ + "static/media/Tetrapack.d36c3f71.png";